import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translations.json";
import de from "./locales/de/translations.json";
import { isGermanPath } from "./components/use-localized-path";

// ✅ Load saved language early (before initialization)
const savedLang = localStorage.getItem("selectedLanguage") || "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
    },
    lng: savedLang, // use saved language directly
    fallbackLng: "en",
    supportedLngs: ["en", "de"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false, // avoid React suspense flicker
    },
  });

// ✅ Keep <html lang> in sync for screen readers, hyphenation, and SEO
document.documentElement.lang = i18n.language;
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

// ✅ Optional safeguard: if route is a German page (/de or /de/...), make sure lang is set
const currentPath = window.location.pathname;
if (isGermanPath(currentPath) && savedLang !== "de") {
  i18n.changeLanguage("de");
  localStorage.setItem("selectedLanguage", "de");
}

export default i18n;
